/**
 * GlobalErrorHandler
 * Handles uncaught errors and provides a centralized error handling mechanism.
 */
import { ErrorHandler, Injectable } from '@angular/core';
import { NotificationService } from '../../services/notification-service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler{

  constructor(
    private _notificationService: NotificationService
  ) { }

  public handleError( error: any ): void
  {
    if ( !error ) return;
    if ( error.error?.title )
    {
      this._notificationService.showErrorMessage( `${error.error?.title}` );
      console.error( error );
      return;
    }
    if ( error.error?.errors )
    {
      const messages: string[] = error.error.errors as string[];      
      this._notificationService.showErrorMessages( messages );
      console.error( error );
      return;
    }
    this._notificationService.showErrorMessage( `${error}` );
    console.error( error );
  }

}
